import ENV, { envInstants } from "libs/configs/env";

export const logoutRedirect = () => {
  const oneLogoutURL = `${ENV.getConfig().oneUrl}/logout?redirect_url=${
    envInstants.getConfig().logoutRedirectUrl
  }`;

  window.location.href = oneLogoutURL;
};
